import { Meteor } from 'meteor/meteor';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { Mongo } from 'meteor/mongo';
import { Roles } from 'roles';

import moment from 'moment';

import { BaseSchema } from '../baseSchema';

import { Flights } from '../flights/flights';

import { HiddenField, NestField, ListField, SelectField } from 'uniforms-bootstrap3';
import DynamicListField from '../../components/fields/dynamicListField';

export const Montgolfieres = new Mongo.Collection('montgolfieres');
export default Montgolfieres;

Montgolfieres.attachRoles('montgolfieres');

Montgolfieres.label = "La montgolfière";

export const MontgolfiereSchema = new SimpleSchema([{
	name: {
		type: String,
		label: "Nom"
	},
	archived: {
		type: Boolean,
		defaultValue: false,
		label: "Archiver ?"
	},
	online: {
		type: Boolean,
 		defaultValue: true,
		label: "En ligne ?",
	},
	place: {
		type: String,
		label: "Lieu d'envol",
		allowedValues: ["anjou", "nantes"],
		defaultValue: "anjou",
		uniforms: {
			component: SelectField,
			transform: (option) => {
				switch (option) {
					case "anjou":
						return "Montgolfieres d'anjou";
					case "nantes":
						return "Montgolfieres de nantes";
					default:
						return "N/C";
				}
			},
		}
	},
	availabilities: {
		type: [Object],
		optional: true,
		blackbox: true,
		hide: true,
		uniforms: {
			component: HiddenField
		}
	},
	maxPassengers: {
		type: Number,
		min: 0,
		defaultValue: 0,
		label: "Nombre de passagers maximum",
	},
	allowedPilots: {
		type: [String],
		label: "Pilotes autorisés",
		hide: true,
		uniforms: {
			component: DynamicListField,
			options: Meteor.users,
			subscription: "users",
			filters: { "roles": {$in: ["pilot"]} },
		}
	},
	"allowedPilots.$": {
		type: String,
		label: "Pilote",
	},
	"defaultWeight": {
		type: Number,
		min: 0,
		defaultValue: 0,
		label: "Masse ballon (en kg)"
	},
	"emptyWeight": {
		type: Number,
		min: 0,
		defaultValue: 0,
		label: "Masse de carburant (en kg)"
	},
	"defaultAllowedWeight": {
		type: Number,
		min: 0,
		defaultValue: 0,
		label: "Masse maximale autorisée par défaut (en kg)"
	},
	maxWeight: {
		type: Object,
		label: "Masses maximales autorisées (en kg)",
		hide: true,
	},
	"maxWeight.temp1": {
		type: Number,
		min: 0,
		defaultValue: 0,
		hide: true,
		label: "0° à 8° C"
	},
	"maxWeight.temp2": {
		type: Number,
		min: 0,
		defaultValue: 0,
		hide: true,
		label: "8° à 16° C"
	},
	"maxWeight.temp3": {
		type: Number,
		min: 0,
		defaultValue: 0,
		hide: true,
		label: "16° à 22° C"
	},
	"maxWeight.temp4": {
		type: Number,
		min: 0,
		defaultValue: 0,
		hide: true,
		label: "22° à 28° C"
	},
	"maxWeight.temp5": {
		type: Number,
		min: 0,
		defaultValue: 0,
		hide: true,
		label: "28° à 36° C"
	},
	"maxWeight.temp6": {
		type: Number,
		min: 0,
		defaultValue: 0,
		hide: true,
		label: "36° et +"
	},

}, BaseSchema]);

Montgolfieres.attachSchema(MontgolfiereSchema);

Montgolfieres.helpers({
	getPlace() {
		if (this.place == 'anjou')
			return "Montgolfieres d'anjou";
		else
			return "Montgolfieres de nantes";

	},
	flightScheduledAt(date, period) {
		return Flights.findOne({
			montgolfiereId: this._id,
			date: moment(date).startOf('day').toDate(),
			period
		});
	}
});



/** WEBPACK FOOTER **
 ** ./src/universal/collections/montgolfieres/montgolfieres.js
 **/